const DESCRIPTION_KEYS = [
  'formDescription',
  'description',
  'formMessage',
  'message',
] as const;

function asRecord(value: object): Record<string, unknown> {
  return value as Record<string, unknown>;
}

/** Copies the resolved description onto `formDescription`. */
export function attachFormDescription<T extends object>(
  payload: T,
): T & { formDescription: string } {
  return {
    ...payload,
    formDescription: readFormDescription(payload),
  };
}

/** First non-empty marketing copy on a form collector payload. */
export function readFormDescription(source: object): string {
  const record = asRecord(source);

  for (const key of DESCRIPTION_KEYS) {
    const value = record[key];
    if (typeof value === 'string' && value.trim()) {
      return value;
    }
  }

  return '';
}

/**
 * Writes the description onto `formDescription` and onto any alternate
 * key the API already returned, so the editor round-trips the stored field.
 */
export function withFormDescription<T extends object>(
  payload: T,
  description: string,
): T {
  const record = asRecord(payload);
  const next: Record<string, unknown> = {
    ...record,
    formDescription: description,
  };

  for (const key of DESCRIPTION_KEYS) {
    if (key !== 'formDescription' && key in record) {
      next[key] = description;
    }
  }

  return next as T;
}
